import { Box, Typography } from "@mui/material";
import React from "react";

import { space, typography } from "../theme/designTokens";

type AuthFormHeaderProps = {
  title: string;
  description: string;
};

export const AuthFormHeader: React.FC<AuthFormHeaderProps> = ({ title, description }) => {
  return (
    <Box sx={{ marginBottom: `${space.xl}px` }}>
      <Typography variant="h4" component="h1" sx={{ marginBottom: `${space.md}px`, fontSize: typography.fontSize.xl }}>
        {title}
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ fontSize: typography.fontSize.xs }}>
        {description}
      </Typography>
    </Box>
  );
};
